import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';

export const useQuoteRoutingContentStyles = createStyles(() => ({
  verticalCenter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },

  labelSmall: {
    color: ThemeColors.COLOR_GREY_BLUISH,
    fontFamily: ThemeFont.FONT_FAMILY,
    fontSize: ThemeFont.FONT_SIZE_XS,
    fontWeight: 400,
    textTransform: 'uppercase',
  },

  valueLarge: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 1,
    color: ThemeColors.COLOR_GREY3,
  },

  valueLargeFixedW: {
    display: 'flex',
    width: 200,
  },

  valueSmall: {
    color: ThemeColors.COLOR_GREY3,
    fontFamily: ThemeFont.FONT_FAMILY,
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    fontWeight: 500,
    lineHeight: 1,
  },

  directDriveIcon: {
    fontSize: ThemeFont.FONT_SIZE_30,
    marginRight: ThemeSpaces.SPACE_NORM,
    color: ThemeColors.COLOR_GREY12,
  },

  flightInfo: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
}));
